const setGradeContainer = (gradeContainer, gradeSentence) => {
    let gradeSentenceArray = gradeSentence.split(' ');
    let grade = gradeSentenceArray[gradeSentenceArray.length - 1].slice(0, -1).replace('.', ',');
    if (grade) {
        gradeContainer.innerHTML = gradeContainer.innerHTML.replace('{beoordeling}', `<strong>${grade}</strong>`);
    }
}

document.addEventListener('DOMContentLoaded', async () => {
    const $gradeContainers = document.getElementsByClassName('has-healthcardscore');
    const $zknWidget = document.querySelector('.zkn');

    if ($zknWidget) {
        Array.from($gradeContainers).forEach(($gradeContainer) => {
            if ($gradeContainer.innerHTML.includes('{beoordeling}')) {
                if (document.querySelector('.zkn-widget__p')) {
                    setGradeContainer($gradeContainer, document.querySelector('.zkn-widget__p').innerText);
                }
                else {
                    var observer = new MutationObserver((mutations) => {
                        mutations.forEach((mutation) => {
                            if (document.querySelector('.zkn-widget__p')) {
                                setGradeContainer($gradeContainer, document.querySelector('.zkn-widget__p').innerText);
                                observer.disconnect();
                            }
                        });
                    });

                    observer.observe($zknWidget, { childList: true, subtree: true });
                }
            }
        });
    }
});
